import { PERMISSIONS_OPTIONS_VALUE } from 'constants/team-members';

const { VIEW_ONLY, EDITOR, NO_ACCESS } = PERMISSIONS_OPTIONS_VALUE;

export const PRODUCTS_AND_CATEGORIES_PERMISSIONS = {
  [VIEW_ONLY]: {
    HIDE_CREATE_PRODUCT: true,
    HIDE_EDIT_PRODUCT: true,
    HIDE_BULK_EDIT_PRODUCT: true,
    HIDE_DELETE_PRODUCT: true,
    DIM_ACTIVATION_TOGGLE: true,
    HIDE_MULTI_SELECT_CHECKBOXES: true,
    HIDE_ACTION_MENUS: true,
    DIM_SELECT_PRODUCTS_FROM_CATEGORIES: true,
    HIDE_CREATE_CUSTOM_CATEGORY: true,
    HIDE_EDIT_CATEGORY: true,
    HIDE_DELETE_CATEGORY: true,
    HIDE_DRAG_AND_DROP_BUTTON_FROM_CATEGORIES: true
  },
  [EDITOR]: {
    HIDE_DELETE_PRODUCT: true,
    HIDE_DELETE_CATEGORY: true
  },
  [NO_ACCESS]: {
    HIDE_CREATE_PRODUCT: true,
    HIDE_EDIT_PRODUCT: true,
    HIDE_BULK_EDIT_PRODUCT: true,
    HIDE_DELETE_PRODUCT: true,
    DIM_ACTIVATION_TOGGLE: true,
    HIDE_MULTI_SELECT_CHECKBOXES: true,
    HIDE_ACTION_MENUS: true,
    DIM_SELECT_PRODUCTS_FROM_CATEGORIES: true,
    HIDE_CREATE_CUSTOM_CATEGORY: true,
    HIDE_EDIT_CATEGORY: true,
    HIDE_DELETE_CATEGORY: true,
    HIDE_DRAG_AND_DROP_BUTTON_FROM_CATEGORIES: true
  }
};
